import { useState, useEffect } from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

function Companycounts({ companyData }) {
    const [myData, setMyData] = useState(null);
    
    useEffect(() => {
        setMyData(companyData);
    }, [companyData]);
    
    function convertJSONToSeries(jsonData) {
        const seriesData = Object.values(jsonData.counts);
        return seriesData;
    }
    
    const xAxisLabels = [
        'Day 1',
        'Day 2',
        'Day 3',
        'Day 4',
        'Day 5',
        'Day 6',
        'Day 7',
        'Week 2',
        'Week 3',
        'Week 4',
        '90day+'
    ];
    
    return (
        <div>
            {myData && (
                <Box>
                    <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', color: '#188182', fontWeight: 500 }}>
                        Suppression Activity Over Time
                    </Typography>
                    
                    <Paper 
                        elevation={0} 
                        sx={{ 
                            p: 2,
                            border: '1px solid #e0e6e8',
                            borderRadius: '8px'
                        }}
                    >
                        <BarChart
                            xAxis={[{ 
                                scaleType: 'band', 
                                data: xAxisLabels,
                                tickLabelStyle: {
                                    fontSize: 12,
                                    angle: 0
                                }
                            }]}
                            series={[
                                { 
                                    data: convertJSONToSeries(companyData.blocks[0]), 
                                    label: 'Blocks', 
                                    color: '#f57c00' // orange
                                },
                                { 
                                    data: convertJSONToSeries(companyData.bounces[0]), 
                                    label: 'Bounces',  
                                    color: '#d32f2f' // red
                                },
                            ]}
                            height={350}
                            margin={{ top: 20, right: 30, bottom: 40, left: 40 }}
                            slotProps={{
                                legend: {
                                    position: {
                                        vertical: 'top',
                                        horizontal: 'middle'
                                    },
                                    itemMarkWidth: 20,
                                    itemMarkHeight: 20,
                                    markGap: 10,
                                    itemGap: 25
                                }
                            }}
                        />
                    </Paper>
                </Box>
            )}
        </div>
    );
}

export default Companycounts;
